import { Html, html, View } from 'rune-ts';
import { DropdownDownIcon } from '@services/MarppleShop/renderApp/components/atoms/Icon';
import klass from './DropdownView.module.scss';
import { htmlIf } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';

export interface DropdownViewProps {
  readonly title: string;

  /**
   * @default false
   */
  defaultOpen?: boolean;

  title_class?: string;
  container_class?: string;
  readonly contentView: View | Html;

  /**
   * @default true
   */
  readonly showArrow?: boolean;
}

export class DropdownView extends View<DropdownViewProps> {
  private _isOpen = this.data.defaultOpen || false;

  protected override onRender(): void {
    super.onRender();

    this.delegate('click', `.${klass.dropdown_toggle_btn}`, () => {
      this.toggle();
    });
  }

  open(): void {
    this._isOpen = true;
    this.element().classList.remove(klass.is_hidden);
  }

  close(): void {
    this._isOpen = false;
    this.element().classList.add(klass.is_hidden);
  }

  toggle(): void {
    this.isOpen ? this.close() : this.open();
  }

  get isOpen(): boolean {
    return this._isOpen;
  }

  protected override template() {
    return html`
      <div
        class="${klass.dropdown_container} ${this.data.container_class || ''} ${htmlIf(
          klass.is_hidden,
          !this.isOpen,
        )}"
      >
        <button class="${klass.dropdown_toggle_btn} ${font('12_bold_px')}">
          <span class="${this.data.title_class || ''}">${this.data.title}</span>
          ${!this.data.showArrow ? '' : html`<span class="${klass.dropdown_icon}">${DropdownDownIcon}</span>`}
        </button>
        <div class="${klass.dropdown_content}">${this.data.contentView}</div>
      </div>
    `;
  }
}
